import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../../../app/theme";

export const useSummaryStyles = makeStyles((theme) => ({
  "root": {
    fontFamily: fontFamily.Axiforma
  },
  "summaryHeader": {
    paddingTop: "30px",
    paddingRight: "35px",
    paddingLeft: "35px"
  },
  "summaryTitle": {
    fontSize: "20px",
    fontWeight: "normal",
    margin: 0
  },
  "summaryDiscountForm": {
    marginTop: "29px",
    paddingBottom: "27px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "solid 1px #979797"
  },
  "summaryDiscountFormInput": {
    "height": "38px",
    "flexBasis": "65%",
    "& input": {
      padding: "13px 11px",
      fontSize: "14px"
    }
  },
  "summaryDiscountFormButton": {
    "background": color.orange,
    "height": "40px",
    "flexBasis": "30%",
    "borderRadius": "18px",
    "fontSize": "14px",
    "color": "#fff",
    "marginTop": "2px",
    "&:hover": {
      background: color.orange
    },
    "&:disabled": {
      background: color.orange,
      color: "#fff"
    }
  },

  "summarySectionTitle": {
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: "normal",
    margin: 0,
    marginTop: "28px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px"
    }
  },

  // summaryPackage

  "summaryPackage": {
    paddingRight: "35px",
    paddingLeft: "35px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "20px",
      paddingLeft: "20px"
    }
  },
  "summaryPackageProduct": {
    display: "flex",
    alignItems: "center",
    marginTop: "30px",
    paddingBottom: "37px",
    borderBottom: "solid 1px #979797",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px"
    }
  },
  "summaryPackageProductImage": {
    "width": "95px",
    "height": "95px",
    "padding": "13px",
    "position": "relative",
    "overflow": "hidden",
    "display": "flex",
    "alignItems": "center",
    "border": "solid 1px #dfdfdf",
    "& img": {
      width: "100%",
      height: "auto",
      objectFit: "cover"
    },
    [theme.breakpoints.down("sm")]: {
      width: "78px",
      height: "78px"
    }
  },
  "summaryPackageProductDetail": {
    marginLeft: "27px",
    display: "flex",
    minHeight: "95px",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      minHeight: "78px"
    }
  },
  "summaryPackageProductName": {
    marginTop: "4px",
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500
  },
  "summaryPackageProductPrice": {
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  "summaryPackageProductButton": {
    "fontSize": "14px",
    "color": "#f7815c",
    "fontWeight": 600,
    "padding": 0,
    "textDecoration": "underline",
    "& a": {
      color: color.orange
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },

  // summaryAddon

  "summaryAddon": {
    paddingRight: "35px",
    paddingLeft: "35px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "20px",
      paddingLeft: "20px"
    }
  },
  "summaryAddonProduct": {
    display: "flex",
    alignItems: "center",
    marginTop: "30px",
    paddingBottom: "37px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px"
    }
  },
  "summaryAddonProductImage": {
    "width": "95px",
    "height": "95px",
    "padding": "13px",
    "position": "relative",
    "overflow": "hidden",
    "display": "flex",
    "alignItems": "center",
    "border": "solid 1px #dfdfdf",
    "& img": {
      width: "100%",
      height: "auto",
      objectFit: "cover"
    },
    [theme.breakpoints.down("sm")]: {
      width: "78px",
      height: "78px"
    }
  },
  "summaryAddonProductDetail": {
    marginLeft: "27px",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      minHeight: "88px"
    }
  },
  "summaryAddonProductName": {
    marginTop: "4px",
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500
  },
  "summaryAddonProductPrice": {
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  "summaryAddonProductButton": {
    fontSize: "14px",
    color: "#f7815c",
    fontWeight: 600,
    padding: 0,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  "summaryAddonQuantityButton": {
    "color": "#f7815c",
    "&:disabled": {
      color: "#d0d0d0"
    }
  },
  // summaryDate

  "summaryDate": {
    background: "#f9f9f9",
    paddingRight: "35px",
    paddingLeft: "35px",
    paddingTop: "33px",
    marginTop: "-1px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-2px",
      paddingRight: "20px",
      paddingLeft: "20px",
      paddingTop: "20px"
    }
  },
  "summaryDateTitle": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "& h3": {
      fontSize: "14px",
      color: "#4b5462",
      fontWeight: "normal",
      margin: 0
    }
  },
  "timer": {
    paddingRight: "8px",
    paddingLeft: "8px",
    fontSize: "14px",
    width: "54px",
    color: "#929292"
  },
  "summaryDateTime": {
    marginTop: "16px"
  },
  "time": {
    fontSize: "16px",
    color: "#43335b",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px"
    }
  },
  "changeTime": {
    fontSize: "14px",
    color: "#f7815c",
    fontWeight: 500,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  "summaryDateContent": {
    marginTop: "14px",
    fontSize: "12px",
    color: "#929292",
    paddingBottom: "22px"
  },
  "summaryTooltip": {
    "& .MuiTooltip-tooltip": {
      background: "#fff",
      color: "#5e6672",
      fontSize: "10px",
      fontFamily: fontFamily.Axiforma,
      padding: "9px 16px",
      boxShadow: "0 5px 15px 0 rgba(0, 0, 0, 0.07)"
    },
    "& .MuiTooltip-arrow": {
      color: "#fff"
    }
  },

  // summaryTotal

  "summaryTotal": {
    paddingRight: "35px",
    paddingLeft: "35px",
    paddingBottom: "40px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "20px",
      paddingLeft: "20px",
      paddingBottom: "20px"
    }
  },
  "summaryTotalPayable": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginTop": "30px",
    "marginBottom": "20px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 500,
      color: "#929292",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& span": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#929292",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
      marginBottom: "12px"
    },
    "&.mt-0": {
      marginTop: "0px"
    }
  },
  "summaryTotalGrant": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "20px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 500,
      color: "#929292",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& span": {
      fontSize: "14px",
      fontWeight: 500,
      color: color.orange,
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "12px"
    }
  },
  "summaryTotalCost": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "& p": {
      margin: 0,
      fontSize: "16px",
      fontWeight: 500,
      color: color.purple[400],
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px"
      }
    },
    "& span": {
      fontSize: "16px",
      fontWeight: 500,
      color: color.purple[400],
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px"
      }
    }
  },
  "summaryTotalCostBoiler": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "& p": {
      margin: 0,
      fontSize: "15px",
      fontWeight: 500,
      color: color.purple[400],
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px"
      }
    },
    "& span": {
      fontSize: "15px",
      fontWeight: 500,
      color: color.purple[400],
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px"
      }
    }
  },
  "summaryDiscount": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "20px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 500,
      color: "#929292",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& .summaryDiscountValue": {
      "display": "flex",
      "alignItems": "center",
      "fontSize": "14px",
      "fontWeight": 500,
      "& span": {
        color: color.orange
      },
      "& button": {
        "padding": 0,
        "marginLeft": "8px",
        "& span": {
          color: "#929292"
        }
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "12px"
    }
  },
  "mr-14": {
    marginRight: "28px"
  },

  // potential

  "potential": {
    "background": color.purple[400],
    "paddingRight": "35px",
    "paddingLeft": "35px",
    "paddingBottom": "40px",
    "fontFamily": fontFamily.Axiforma,
    "display": "grid",
    "overflow": "hidden",
    "position": "relative",
    "boxShadow": "0 5px 15px 0 rgba(0, 0, 0, 0.07)",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "20px",
      paddingLeft: "20px",
      paddingBottom: "28px"
    },
    "&.graphHidden": {
      paddingTop: "40px",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "28px"
      }
    }
  },
  "potentialSaving": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "paddingTop": "30px",
    "marginBottom": "20px",
    "& p": {
      margin: 0,
      fontSize: "16px",
      fontWeight: 500,
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "20px"
    }
  },
  "potentialSavingButton": {
    "fontSize": "12px",
    "color": "#fff",
    "fontWeight": "bold",
    "padding": 0,
    "textDecoration": "underline",
    "& .MuiButton-label": {
      fontSize: "12px",
      color: "#fff",
      fontWeight: "bold"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px"
    }
  },
  "potentialLifeTime": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "10px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 500,
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& span": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    }
  },
  "potentialOutlay": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "10px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 500,
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& span": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    }
  },
  "potentialNet": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "& p": {
      margin: 0,
      fontSize: "16px",
      fontWeight: 500,
      color: color.orange,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px"
      }
    },
    "& span": {
      fontSize: "16px",
      fontWeight: 500,
      color: color.orange,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px"
      }
    }
  },
  "summaryDialog": {
    "& .MuiDialog-paper": {
      width: "100%",
      margin: "18px"
    },
    "& .MuiDialogTitle-root": {
      padding: 0,
      boxShadow: "0 -2px 7px 0 rgba(0, 0, 0, 0.07)"
    }
  },
  "summaryDialogContent": {
    padding: 0,
    paddingBottom: "80px",
    maxHeight: "80vh",
    overflow: "auto"
  },
  "summaryDialogTitle": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "padding": "20px",
    "boxShadow": "0 -2px 7px 0 rgba(0, 0, 0, 0.07)",
    "& h2": {
      margin: 0,
      fontSize: "18px",
      color: "#4b5462"
    },
    "& .MuiIconButton-root": {
      padding: 0
    }
  },
  "summaryDialogBottom": {
    boxShadow: "0 -2px 7px 0 rgba(0, 0, 0, 0.07)",
    padding: 0
  },
  "inputStepper": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "borderRadius": "18px",
    "width": "129px",
    "height": "38px",
    "background": "#f9f9f9",
    "fontSize": "14px",
    "marginTop": "15px",
    "marginBottom": "15px",
    "& button": {
      padding: "8px"
    },
    "& input": {
      width: "50%",
      background: "#f9f9f9",
      border: 0,
      outline: 0,
      textAlign: "center"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "12px",
      marginBottom: "12px"
    }
  },
  "summarySubscription": {
    display: "flex",
    alignItems: "center",
    marginTop: "30px",
    paddingBottom: "37px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px"
    }
  },
  "summarySubscriptionImage": {
    "width": "95px",
    "height": "146px",
    "position": "relative",
    "overflow": "hidden",
    "display": "flex",
    "alignItems": "center",
    "border": "solid 1px #dfdfdf",
    "& img": {
      width: "auto",
      height: "146px",
      objectFit: "cover"
    },
    [theme.breakpoints.down("sm")]: {
      width: "78px",
      height: "78px"
    }
  },
  "summarySubscriptionDetail": {
    marginLeft: "27px",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "146px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "146px"
    }
  },
  "summarySubscriptionName": {
    marginTop: "4px",
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500
  },
  "summarySubscriptionDescription": {
    fontSize: "12px",
    color: "#929292",
    marginBottom: "26px"
  },
  "summarySubscriptionPrice": {
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  "summarySubscriptionButton": {
    fontSize: "14px",
    color: "#f7815c",
    fontWeight: 600,
    padding: 0,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  }
}));
